import styles from "./index.module.scss";
import PlusIcon from "../../../icons/plus.icon";

const IPWhitelistForm = ({ ipInput, onInputChange, onAdd, error, isLoading }) => {
  return (
    <section
      className={styles.whitelistSection}
      aria-labelledby="ip-whitelist-label"
    >
      <div className={styles.whitelistCard}>
        <div className={styles.whitelistForm}>
          <div className={styles.whitelistInputGroup}>
            <label
              id="ip-whitelist-label"
              htmlFor="ip-address-input"
              className={styles.whitelistLabel}
            >
              IP address whitelist
            </label>

            <div className={`${styles.whitelistInputWrapper} ${error ? styles.whitelistInputWrapperError : ''}`}>
              <div className={styles.whitelistInputInner}>
                <input
                  id="ip-address-input"
                  type="text"
                  value={ipInput}
                  onChange={(e) => onInputChange(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !isLoading) {
                      e.preventDefault();
                      onAdd();
                    }
                  }}
                  placeholder="Eg. 192.168.1.1 or 192.168.1.0/24"
                  className={`${styles.whitelistInput} ${error ? styles.whitelistInputError : ''}`}
                  aria-label="IP address input"
                  aria-invalid={error ? "true" : "false"}
                  aria-describedby={error ? "ip-error-message" : undefined}
                />
              </div>
            </div>
            {error && (
              <div id="ip-error-message" className={styles.errorMessage} role="alert">
                {error}
              </div>
            )}
          </div>

          <button
            onClick={onAdd}
            className={styles.addButton}
            aria-label="Add IP address"
            disabled={isLoading}
          >
            <div className={styles.addButtonIcon}>
              <PlusIcon className={styles.icon20} /> 
            </div>

            <div className={styles.addButtonText}>
              <span className={styles.addButtonLabel}>Add</span>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default IPWhitelistForm;

